export default __webpack_public_path__ + "static/media/Bloodbeggar Shafts.9f20a812.jpg";